import { AppInput } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { Mail } from 'lucide-react'
import { useCallback, useEffect, useState } from 'react'
import { VALIDATION_MESSAGES } from 'shared'

interface EmailInputProps {
  value: string
  onChange: (value: string) => void
  onValidChange?: (isValid: boolean) => void
  required?: boolean
  tabIndex?: number
  name?: string
  autoComplete?: string
}

export function EmailInput({
  value,
  onChange,
  onValidChange,
  required = true,
  tabIndex = 1,
  name = 'email',
  autoComplete = 'username',
}: EmailInputProps) {
  const [error, setError] = useState<string | null>(null)
  const [touched, setTouched] = useState(false)

  const validate = useCallback(
    (val: string) => {
      if (required && !val) {
        return VALIDATION_MESSAGES.REQUIRED
      }
      if (val && val.length < 6) {
        return VALIDATION_MESSAGES.minLength(6)
      }
      if (val && val.length > 96) {
        return VALIDATION_MESSAGES.maxLength(96)
      }
      return null
    },
    [required],
  )

  useEffect(() => {
    const errorMsg = validate(value)
    if (touched) {
      setError(errorMsg)
    }
    onValidChange?.(errorMsg === null)
  }, [value, touched, onValidChange, validate])

  const handleBlur = () => {
    setTouched(true)
    const errorMsg = validate(value)
    setError(errorMsg)
    onValidChange?.(errorMsg === null)
  }

  return (
    <AppInput
      id={name}
      name={name}
      label='ログインID'
      type='email'
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onBlur={handleBlur}
      tabIndex={tabIndex}
      autoComplete={autoComplete}
      leftIcon={<Mail />}
      maxLength={96}
      showCharCount
      error={error && touched ? error : undefined}
    />
  )
}
